import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

/**
 * Tooltip Component - INFLUENCITY-TIER
 * 
 * Contract:
 * - Soft glass, readable text
 * - Not harsh primary color
 * - Both default and helper variants readable
 * 
 * All colors route through granullo.tokens.css
 */

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef(({ className, sideOffset = 4, variant = "default", ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        // Base styles
        "z-50 overflow-hidden px-3 py-2 text-sm font-medium",
        "rounded-[var(--g-radius-md)]",
        // Animation
        "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-tooltip-content-transform-origin]",
        // Default variant: glass popover
        variant === "default" && "bg-[var(--g-popover-bg)] text-[var(--g-text)] border border-[var(--g-popover-border)] shadow-[var(--g-popover-shadow)] backdrop-blur-[var(--g-glass-blur)]",
        // Helper variant: softer
        variant === "helper" && "bg-[var(--g-surface-solid)] text-[var(--g-text-secondary)] border border-[var(--g-border)] shadow-[var(--g-shadow-mid)]",
        className
      )}
      {...props} />
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

/**
 * HelperTooltip - Pre-configured for explanatory content
 */
const HelperTooltip = React.forwardRef(({ children, content, side = "top", ...props }, ref) => (
  <Tooltip>
    <TooltipTrigger asChild ref={ref}>
      {children}
    </TooltipTrigger>
    <TooltipContent variant="helper" side={side} {...props}>
      <div className="max-w-[280px] leading-relaxed text-[var(--g-text-secondary)]">
        {content}
      </div>
    </TooltipContent>
  </Tooltip>
))
HelperTooltip.displayName = "HelperTooltip"

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider, HelperTooltip }
